import { EMPTY_LIST } from '../../../constants/common'
import i18n from '../../../i18n'
import { REPORT_TABLE_MODAL_CELL_NAME } from '../../ReportTableModal'

import { FILE_VIEWS_REPORT_UNKNOWN_USER_NAME_KEY } from './DocumentViewReportModal.constants'

function getFileViewsReportOwner(user) {
  return (
    user ?? {
      fullname: i18n.t(FILE_VIEWS_REPORT_UNKNOWN_USER_NAME_KEY),
      is_system: true,
    }
  )
}

export function getFileViewsReportItemsData(data) {
  return {
    items: data.items.map(item => {
      const owner = getFileViewsReportOwner(item.user)

      return {
        ...owner,
        [REPORT_TABLE_MODAL_CELL_NAME.date]: item.last_view_dt,
        [REPORT_TABLE_MODAL_CELL_NAME.owner]: owner,
        [REPORT_TABLE_MODAL_CELL_NAME.views]: item.views_count,
      }
    }),
  }
}

export function getFileViewsReportRequestParams(parentId) {
  return ({ ordering, page, pageSize }) => ({
    filters: { parent: parentId },
    ordering: ordering ?? EMPTY_LIST,
    pagination: { page, size: pageSize },
  })
}
